import React from 'react'
import styled from 'styled-components'
import { size } from './platform'

export const Overlay = styled((props: any) => <div {...props}></div>)`
  @media only screen and (max-width: ${size.md}) {
    visibility: hidden;
    display: flex;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    transition: opacity 0.3s ease, transform 0.2s ease;
    ${(props) =>
      props.isExpanded ? 'visibility: visible; opacity: 1;' : 'opacity: 0;`'}
  }
`
